import {
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonIcon,
    IonTitle,
    IonProgressBar,
} from '@ionic/react';
import { chevronBackOutline, closeOutline } from 'ionicons/icons';
import '../../theme/FlowModal.css';

/**
 * Header shared by the step-by-step modals: Back, title, Close and a progress
 * bar. `step` is 1-based; pass step={0} for an introductory page that is not
 * counted, and omit onBack / onClose to hide those buttons.
 */
function FlowModalHeader({ title, step, totalSteps, onBack, onClose, closeLabel = 'Close' }) {
    return (
        <IonHeader className='flow-header'>
            <IonToolbar>
                <IonButtons slot='start'>
                    {onBack && (
                        <IonButton onClick={onBack}>
                            <IonIcon slot='start' icon={chevronBackOutline} />
                            Back
                        </IonButton>
                    )}
                </IonButtons>
                <IonTitle>{title}</IonTitle>
                <IonButtons slot='end'>
                    {onClose && (
                        <IonButton onClick={onClose} aria-label={closeLabel}>
                            <IonIcon slot='icon-only' icon={closeOutline} />
                        </IonButton>
                    )}
                </IonButtons>
            </IonToolbar>
            {step > 0 && totalSteps > 0 && (
                <IonProgressBar
                    value={step / totalSteps}
                    aria-label={`Step ${step} of ${totalSteps}`}
                />
            )}
        </IonHeader>
    );
}

export default FlowModalHeader;
